import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=67b0cbb4&scoped=true&"
import script from "./LoadingDots.vue?vue&type=script&lang=js&"
export * from "./LoadingDots.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDots.vue?vue&type=style&index=0&id=67b0cbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0cbb4",
  null
  
)

export default component.exports